"use strict";

function e(e) {
  return e && "object" == typeof e && "default" in e ? e : {
    default: e
  };
}
Object.defineProperty(exports, "__esModule", {
  value: !0
});
var t = e(require("react"));
function r() {
  return (r = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }).apply(this, arguments);
}
function n(e, t) {
  if (null == e) return {};
  var r,
    n,
    a = function (e, t) {
      if (null == e) return {};
      var r,
        n,
        a = {},
        l = Object.keys(e);
      for (n = 0; n < l.length; n++) r = l[n], t.indexOf(r) >= 0 || (a[r] = e[r]);
      return a;
    }(e, t);
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(e);
    for (n = 0; n < l.length; n++) r = l[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (a[r] = e[r]);
  }
  return a;
}
var a = ["value", "stringDate", "stringDates", "placeholder", "handleValueChange", "separator", "openCalendar", "className", "type", "children"];
exports.default = function (e) {
  var l = e.value;
  e.stringDate, e.stringDates;
  var o = e.placeholder;
  e.handleValueChange, e.separator;
  var c = e.openCalendar,
    u = e.className,
    s = void 0 === u ? "rmdp-button" : u;
  e.type;
  var i = e.children,
    p = n(e, a),
    f = i || l || o || "click to select";
  return t.default.createElement("button", r({
    onClick: c,
    className: s
  }, p), f);
};